import React from "react";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiAvatar from "components/SuiAvatar";

function ImageUpload({
  image,
  onChange,
  disabled = false,
  label = "Choose Image",
  id = "image-upload",
  previewHeight = 80,
  avatarHeight = 40,
  avatarLabel = "Upload",
  width = 150,
}) {
  return (
    <SuiBox my={1}>
      <label htmlFor={id} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "16px" }}>
        <input
          id={id}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          disabled={disabled}
          onChange={onChange}
        />
        <SuiBox py={1} pr={2}>
          <SuiTypography variant="h6">{label}</SuiTypography>
          <SuiAvatar
            alt="image"
            style={{
              width: "auto",
              height: avatarHeight,
              borderRadius: 8,
              color: "white",
              fontSize: "12px",
              border: "1px solid #D2D6DA",
              padding: "0 12px",
              backgroundColor: "#252a47",
              marginTop: "6px",
            }}
          >
            {avatarLabel}
          </SuiAvatar>
        </SuiBox>
      </label>
      {image && (
        <SuiBox mt={1} style={{ border: "1px solid #ddd", padding: "4px", borderRadius: "8px", width }}>
          <img
            src={image instanceof File ? URL.createObjectURL(image) : image}
            alt="Preview"
            style={{
              width: "100%",
              height: previewHeight,
              borderRadius: "6px",
              objectFit: "cover",
            }}
          />
        </SuiBox>
      )}
    </SuiBox>
  );
}

export default ImageUpload;
